export default {
  helpText: `<p class="mb-4">Platforma Treści i Multimediów to narzędzie, które umożliwi Państwu złożenie zamówienia na
  przygotowanie treści i multimediów przez zespół Departamentu Komunikacji i Promocji NBP.</p>
  <p class="mb-4">Wszelkie informacje na temat funkcjonowania tego narzędzia znajdą Państwo w Intranecie NBP pod
  adresem:</p>
  <a href="http://intranet.int.nbp.pl/nbp/Strony/pwm.aspx" target="_blank" rel="nofollow"><p class="mb-4">http://intranet.int.nbp.pl/nbp/Strony/pwm.aspx</p></a> `,
};
